import { Alert, AlertTitle } from '@mui/material';
import React from 'react';

interface KeyTakeawayProps {
    text: string;
}

const KeyTakeaway: React.FC<KeyTakeawayProps> = ({ text }) => {
    if (!text) return null;
    return (
        <Alert severity="info" sx={{ mt: 2 }} data-testid="key-takeaway">
            <AlertTitle>Key Takeaway</AlertTitle>
            {text}
        </Alert>
    );
};

export default KeyTakeaway;
